const ENDPOINT = '/api/chat';

const SEEKERS_INIT = 'SEEKERS/SEEKERS_INIT';
const SEEKERS_SUCCESS = 'SEEKERS/SEEKERS_SUCCESS';
const SEEKERS_FAILED = 'SEEKERS/SEEKERS_FAILED';

const SEEKER_INIT = 'SEEKERS/SEEKER_INIT';
const SEEKER_SUCCESS = 'SEEKERS/SEEKER_SUCCESS';
const SEEKER_FAILED = 'SEEKERS/SEEKER_FAILED';

const SEEKER_PREFERENCES_INIT = 'SEEKERS/SEEKER_PREFERENCES_INIT';
const SEEKER_PREFERENCES_SUCCESS = 'SEEKERS/SEEKER_PREFERENCES_SUCCESS';
const SEEKER_PREFERENCES_FAILED = 'SEEKERS/SEEKER_PREFERENCES_FAILED';

const initialState = {
  data: {},
  loading: false
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SEEKER_PREFERENCES_INIT:
    case SEEKER_INIT:
    case SEEKERS_INIT:
      return {
        data: initialState.data,
        loading: true
      };
    case SEEKER_PREFERENCES_SUCCESS:
    case SEEKER_SUCCESS:
    case SEEKERS_SUCCESS:
      return {
        data: action.payload,
        loading: false
      };
    case SEEKER_PREFERENCES_FAILED:
    case SEEKER_FAILED:
    case SEEKERS_FAILED:
      return {
        data: initialState.data,
        loading: false
      };
    default:
      return state;
  }
}

export function seekers(data) {
  return {
    types: [SEEKERS_INIT, SEEKERS_SUCCESS, SEEKERS_FAILED],
    promise: (client) => client.post(`${ENDPOINT}/requestSeekers`, { data })
  };
}

export function seeker(id) {
  return {
    types: [SEEKER_INIT, SEEKER_SUCCESS, SEEKER_FAILED],
    promise: (client) => client.get(`${ENDPOINT}/requestSeeker/${id}`)
  };
}

export function seekerPreferences(id) {
  return {
    types: [
      SEEKER_PREFERENCES_INIT,
      SEEKER_PREFERENCES_SUCCESS,
      SEEKER_PREFERENCES_FAILED
    ],
    promise: (client) => client.get(`${ENDPOINT}/requestPreference/${id}`)
  };
}
